import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import SearchableSelect from '../SearchableSelect/SearchableSelect';
import { IProductGroup } from '../../../modules/API/Products/models/productGroup';
import LayersIcon from '../../icons/IconLib/LayersIcon';

interface Props {
    groups: IProductGroup[];
    /** Selected GroupID; 0 — all groups. */
    value: number;
    onSelect: (groupID: number) => void;
    placeholder?: string;
    disabled?: boolean;
    readOnly?: boolean;
    className?: string;
}

/** Order / product group picker (product/group) with an "all groups" clear option. */
const OrderGroupSelector: React.FC<Props> = ({
    groups,
    value,
    onSelect,
    placeholder,
    disabled,
    readOnly,
    className,
}) => {
    const [t] = useTranslation('selectors');
    const selected = useMemo(() => groups.find((g) => g.GroupID === value) ?? null, [groups, value]);

    return (
        <SearchableSelect<IProductGroup>
            items={groups}
            value={selected}
            onSelect={(g) => onSelect(g ? g.GroupID : 0)}
            getKey={(g) => g.GroupID}
            getLabel={(g) => (g.GroupDesc ?? '').trim()}
            placeholder={placeholder ?? t('selectors_orderGroup_placeholder')}
            disabled={disabled}
            readOnly={readOnly}
            leadingIcon={<LayersIcon />}
            allowClear
            clearLabel={t('selectors_orderGroup_all')}
            emptyLabel={t('selectors_orderGroup_empty')}
            className={className}
        />
    );
};

export default OrderGroupSelector;
